import React from "react";
import { Box, VStack } from "@chakra-ui/react";

export default function Card({
  children,
  icon: Icon,
  title,
  description,
  ...rest
}) {
  return (
    <Box
      p={8}
      bg="white"
      borderRadius="2xl"
      boxShadow="0 4px 20px rgba(0,0,0,0.08)"
      _hover={{
        boxShadow: "0 12px 40px rgba(16, 185, 129, 0.2)",
        transform: "translateY(-4px)",
      }}
      transition="all 0.3s"
      {...rest}
    >
      {Icon && (
        <Box fontSize="3xl" mb={4} color="#10B981">
          <Icon />
        </Box>
      )}
      {children || (
        <VStack align="start" spacing={4}>
          {title && (
            <Box fontSize="xl" fontWeight="600" color="#1E293B">
              {title}
            </Box>
          )}
          {description && (
            <Box color="#475569">
              {description}
            </Box>
          )}
        </VStack>
      )}
    </Box>
  );
}
